import { ValueInput } from '@utils/formattersV2';

export const formatWithSign = (
  value: ValueInput,
  formatter: (value: ValueInput) => string
) => [(value ?? 0) > 0 ? '+' : '', formatter(value)].join('');
